export const API_CONFIG = {
  BASE_URL: 'https://api.instasd.com/api_endpoints/3s6daq41e5g3tt',
  API_KEY: 'RAOahaBsiVWmURWFNKyRnQ',
  INPUT_IDS: {
    PROMPT: '4c07f4156abe8819',
    IMAGE: 'b01a81fd590d6bcc'
  }
} as const;